import { render, staticRenderFns } from "./CanAttach.vue?vue&type=template&id=358f5454&"
import script from "./CanAttach.vue?vue&type=script&lang=js&"
export * from "./CanAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports